import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/promocodes/promocodeController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import SkeltonList from "../../../components/SkeltonEffect/list";
import Pagination from "@mui/material/Pagination";

const PreviewPopUp = ({ popUpOpen, togglePopUp, upload_file={}, process }) => {
  const handleCancel = () => {
    togglePopUp();
    setCurrentRows([]);
    setTotalPages(0)

  }

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const[ jsonData, setJsonData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [start, setStart] = useState(0);
  const [currentRowsData, setCurrentRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [countData, setCountData] = useState({});

  const getFileData = async () => {
    try {
      if(!upload_file){
        setJsonData([]);
      } else {
        // setIsLoading(true);
        const fileBuffer = await getFileBuffer(upload_file);
        const workbook = XLSX.read(fileBuffer, { type: 'buffer' });
        
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        // Convert the sheet to JSON
        const result = XLSX.utils.sheet_to_json(worksheet);        
        setJsonData(result);

        // {items['STRAIGHT AMOUNT'] > 0 && 'Straight '}
        // {items['RUMBLE AMOUNT'] > 0 && 'Rumble '}
        // {items['CHANCE AMOUNT'] > 0 && 'Chance'}
        const countResult = result.reduce(
          (acc, item) => {
            acc.totalCount += 1;
            acc.totalPoint += parseFloat(item['WINNING AMOUNT']);
            if(item['STRAIGHT AMOUNT'].toString() === '1'){
              acc.straightPoint += parseFloat(item['WINNING AMOUNT']);
            } else if(item['RUMBLE AMOUNT'].toString() === '1'){
              acc.rumblePoint += parseFloat(item['WINNING AMOUNT']);
            } else if(item['CHANCE AMOUNT'].toString() === '1'){
              acc.chancePoint += parseFloat(item['WINNING AMOUNT']);
            }
            return acc;
          },
          { totalCount : 0, totalPoint : 0, straightPoint : 0, rumblePoint : 0, chancePoint : 0 }
        )
        setCountData(countResult);
        const start = (currentPage - 1) * rowsPerPage;
        const currentRows = result.slice(start, start + rowsPerPage);
        const totalPages = Math.ceil(result?.length / rowsPerPage);
        setStart(start);
        setCurrentRows(currentRows);
        setTotalPages(totalPages);
      }
    } catch (error) {
      console.log('error',error);
      // alert("Error generating Excel file: " + error.message);
    }
  };

  const getFileBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        resolve(reader.result);
      };
  
      reader.onerror = (error) => {
        reject(error);
      };
  
      reader.readAsArrayBuffer(file);
    });
  };

  // useEffect(()=>{
  //   if(upload_file && (upload_file?.type === 'text/csv' || upload_file?.type === 'application/vnd.ms-excel')){
  //     getFileData();
  //   } else{
  //     setCurrentRows([]);
  //     setTotalPages(0);
  //   }
  // },[popUpOpen]);
  useEffect(() => {
    if (upload_file) {
      const ext = upload_file.name.split('.').pop().toLowerCase();
      if (['csv', 'xls', 'xlsx'].includes(ext)) {
        getFileData();
      } else {
        setCurrentRows([]);
        setTotalPages(0);
      }
    }
  }, [popUpOpen]);

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    const start = (newPage - 1) * rowsPerPage;
    const currentRows = jsonData.slice(start, start + rowsPerPage);

    setStart(start);
    setCurrentRows(currentRows);
  };

  const handleUpload = () => {
    try {
      handleCancel();
      process();
    } catch (error) {
      
    }
  }

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Lotto Winner's Preview
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <div>
          <div className="inventory_all_tabs">
            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Winners Nos. : {`${countData?.totalCount}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Straight Amount : {`${countData?.straightPoint}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Rumble Amount : {`${countData?.rumblePoint}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Chance Amount : {countData?.chancePoint}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Total Amount : {countData?.totalPoint}</label>
            </div>
          </div>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form>
                <div className="form-group row">
                  {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label htmlFor="code" className="all_lable_for_vendor_dashbaord">Search :</label>
                    <input type="text" name="name" id="name" placeholder="Search" className="form-control categories_select_tg_enter_product" />
                  </div> */}

                  <div id="content-wrapper" className="d-flex flex-column">
                    <div className="card shadow mb-4">
                      <div className="card-body pt-0">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>Sl. No.</th>
                                <th>Order No.</th>
                                <th>Seller's Details</th>
                                <th>Coupon Code</th>
                                <th>Matching Code</th>
                                <th>Game Type</th>
                                <th>Winner Type</th>
                                <th>Winning Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentRowsData?.length > 0 ? (
                                currentRowsData.map((items, index) => (
                                  <>
                                    <tr key={index}>
                                      <td> {index + 1} </td>
                                      <td>{items['TICKET ID']}</td>
                                      <td>
                                        Name : {`${items['SELLER FIRST NAME']} ${items['SELLER LAST NAME']}`} <br/>
                                        Ph. No : {items['SELLER MOBILE']}
                                      </td>

                                      <td>{items['COUPONS']}</td>
                                      <td>{items['MATCHING NUMBER']}</td>
                                      <td>
                                        {items['STRAIGHT AMOUNT'] > 0 && 'Straight '}
                                        {items['RUMBLE AMOUNT'] > 0 && 'Rumble '}
                                        {items['CHANCE AMOUNT'] > 0 && 'Chance'}
                                      </td>
                                      <td>{items['WINNER TYPE']}</td>
                                      <td>{items['WINNING AMOUNT']}</td>
                                      
                                    </tr>
                                  </>
                                ))
                              ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                                  <td colspan="8" className="img-center" >No data found !</td> 
                              </tr>}
                            </tbody>
                          </table>
                          {totalPages > 0 && (
                            <div className="table_pagination_sales_order">
                              <Pagination
                                count={parseInt(totalPages)}
                                onChange={handlePageChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="button" className="btn btn-danger" disabled={isLoading} onClick={handleUpload}>Upload</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
    </Dialog>
  );
};

export default PreviewPopUp;
